<div class="loader">
  <ion-img class="logo" src="/assets/image/retailerlogo.png"></ion-img>
  <ion-text class="ion-text-center">
    {{ message }}
  </ion-text>
</div>